import React from "react";
import {ListGroupItem, ListGroup , Row, Col, Grid ,FormGroup,Form,FormControl ,ControlLabel,Checkbox,MenuItem,DropdownButton,ButtonToolbar,Button} from 'react-bootstrap'
import Features from "../Features/Features";
import Breadcrumbing from "../Breadcrumbing/Breadcrumbing";
import Signwith from "../Signwith/Signwith";

class UserSetting extends React.Component {
	
	 render() {     
		return (
      <div className="user__sidebar">

            <Breadcrumbing/>

            <Col md={3}>
            
   

<ListGroup>
  <ListGroupItem href="/userprofile">
  User Information
  </ListGroupItem>
  <ListGroupItem href="/AddShipping">Shipping Address</ListGroupItem>
    <ListGroupItem href="/ordershistory">  Orders History</ListGroupItem>
       <ListGroupItem href="/paymentmethod"  active>  Payment Methods</ListGroupItem>
       <ListGroupItem href="/reviewrating">    Reviews & Rating</ListGroupItem>
       





</ListGroup>

          </Col>
          </div>



       );
    }
  }
  
export default UserSetting;
  


// WEBPACK FOOTER //
// ./src/Components/UserSetting/UserSetting.jsx